import { render, staticRenderFns } from "./UpdateCourseReview.vue?vue&type=template&id=1c3b2ed8&scoped=true"
import script from "./UpdateCourseReview.vue?vue&type=script&lang=js"
export * from "./UpdateCourseReview.vue?vue&type=script&lang=js"
import style0 from "./UpdateCourseReview.vue?vue&type=style&index=0&id=1c3b2ed8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3b2ed8",
  null
  
)

export default component.exports